export default __webpack_public_path__ + "static/media/gallery_03.a77ffa76.jpg";